import { TitledPaper } from '@dai/components'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2 as Grid,
  Link,
  Typography,
} from '@mui/material'
import { useState } from 'react'

import PricingTable from '@/components/account-set-up/steps/pricing/PricingTable'
import usePricingTable from '@/components/account-set-up/steps/pricing/usePricingTable'
import CreateAccount from '@/components/auth/CreateAccount'
import { useRemoteConfig } from '@/contexts/RemoteConfigContext'
import useT from '@/i18n/useT'

function SignUp() {
  const { t } = useT()
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const { enablePayments } = useRemoteConfig()

  const { plans, checkoutInfo, plansLoading, plansError } = usePricingTable()

  return (
    <Grid container spacing={6}>
      <Grid size={{ xs: 12 }}>
        {enablePayments && (
          <Link
            component="button"
            variant="body2"
            onClick={handleOpen}
            sx={{
              color: 'red',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            {t('signUp.seePricing')}
          </Link>
        )}
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
          <DialogTitle>
            {t('signUp.pricingDialog.title')}
            <Typography variant="body2" color="text.secondary">
              {t('signUp.pricingDialog.subtitle')}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <PricingTable
              viewOnly
              handleSelectPlan={() => {}}
              selectedPlan={null}
              plans={plans}
              loading={plansLoading}
              error={plansError}
              checkoutInfo={checkoutInfo}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              {t('signUp.close')}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TitledPaper title={t('signup.title')} subtitle={t('signup.subtitle')}>
          <CreateAccount />
        </TitledPaper>
      </Grid>
    </Grid>
  )
}

export default SignUp
